module.exports = __webpack_public_path__ + "static/media/contactless-card.a99b5dc5.svg";